<template>
    <div>
        <base-button-icon
            @click="openInfo"
            icon-name="info"
        />

        <base-modal
            @modalClose="showModal = false"
            :show-modal="showModal"
            :modal-image="modalImage"
        >
            <template v-slot:header>
            </template>

            <template v-slot:content>
                <h1 class="mb-2 font-bold">
                    {{ modalHeading }}
                </h1>

                <p class="mb-3">
                    {{ modalCopy }}
                </p>
            </template>
        </base-modal>
    </div>
</template>

<script>
    import BaseButtonIcon from './BaseButtonIcon.vue';
    import BaseModal from './BaseModal.vue';

    export default {
        components: {
            BaseButtonIcon,
            BaseModal,
        },

        props: {
            modalHeading: {
                type: String,
                default: '',
            },
            modalCopy: {
                type: String,
                required: true,
            },
            modalImage: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                showModal: false,
            };
        },

        methods: {
            openInfo() {
                this.showModal = true;
            },
        },
    };
</script>
